<script setup>
import { reactive, ref } from "vue";
import { useDishesStore } from "@/stores/storeDishes";
import BaseTextarea from "@/components/ui/BaseTextarea.vue";
import BasePictureCropper from "@/components/ui/BasePictureCropper.vue";

const storeDishes = useDishesStore();

const props = defineProps({
	dish: Object,
	index: Number,
	isControls: {
		type: Boolean,
		default: true
	},
	isInteriorMode: { 
		type: Boolean, 
		default: false 
	},
	readonly: {
		type: Boolean,
		default: false
	}
});

const userDishesApplication = reactive({
	photo: props.dish.picture,
	isPicAdd: false,
})

const emit = defineEmits(["delete"]);
</script>
<template>
	<div :class="['dish', { 'not-controls': !isControls }]">
		<div class="dish__box">
			<div class="dish__pic">
				<!-- Фото интерьера (добавится только при нужном статусе) -->
				<BasePictureCropper 
					v-if="isInteriorMode" 
					v-model:photo="props.dish.photo_interior" 
					:userApplication="userDishesApplication" 
				/>
				 <!-- Фото самого блюда -->
				<BasePictureCropper 
					v-else 
					v-model:photo="props.dish.picture" 
					:userApplication="userDishesApplication"
				/>
			</div>
			<div class="dish__controls" >
				<h4 class="dish__name">Блюдо № {{ index + 1 }}</h4>
				<button v-if="isControls" type="button" class="dish__delete-btn" @click="emit('delete')">Удалить</button>
			</div>
			<BaseTextarea :readonly="readonly" class="dish__textarea" :max-length="300" :state-key="`message`" v-model="props.dish.description" placeholder="Пример">Описание блюда / состав / как сочетается с Courvoisier</BaseTextarea>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.dish {
    &:not(:first-child) {
        padding-top: 3.4rem;
    }
    &:not(:last-child) {
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 3.4rem;
    }

	&.not-controls {
	}
}
.dish__box {
	width: 100%;
	display: grid;
	grid-template-columns: 33.8rem 1fr;
    grid-template-rows: 20px 1fr;
	gap: 2.6rem 2rem;
	align-items: stretch;
	@media (max-width: vars.$m) {
		grid-template-columns: 1fr;
		gap: 20px;
		grid-template-rows: 20px 1fr auto;
		align-items: start;
		justify-items: center;
	}
	
}
.dish__pic {
	width: 100%;
	grid-column: 1/2;
	grid-row: 1/3;
	@media (max-width: vars.$m) {		
		width: 33.8rem;
		grid-column: 1/2;
		grid-row: 2/3;
	}
	@media (max-width: vars.$x425) {
		width: 100%;
	}
}
.dish__controls {
	display: flex;
	align-items: center;
    gap: 1.6rem;
	grid-column: 2/3;
	grid-row: 1/2;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 1/2;		
		width: 100%;
	}
}
.dish__name {
	font-family: var(--font-family-md);
	font-weight: 500;
	font-size: 2rem;
	line-height: 120%;
	color: var(--red);
}
.dish__delete-btn {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 120%;
    color: rgba(29, 29, 27, 0.5);
    border-bottom: 1px solid currentColor;
    @media (hover: hover){
        &:hover {
            border-color: transparent;
        }
    }
}
.dish__textarea {
	grid-column: 2/3;
	grid-row: 2/3;
	@media (max-width: vars.$m) {
		grid-column: 1/2;
		grid-row: 3/4;
		width: 100%;
	}
}
</style>
